import http from "@/util/http.js"
const PREFIX = "/profile"

export default {
    async list(withSystemProfiles, customConfig)
    {
        return await http.get(PREFIX + (withSystemProfiles ? "?withSystemProfiles=true" : ""), {customConfig})
    },
    async get(perfilId, customConfig)
    {
        return await http.get(PREFIX + "/" + perfilId, {customConfig})
    },
    async save(perfil, customConfig)
    {
        return await http.post(PREFIX, perfil, {customConfig})
    },
    async delete(perfilId, customConfig)
    {
        return await http.delete(PREFIX + "/" + perfilId, {customConfig})
    },
    async listPermissoes(perfilId, customConfig)
    {
        if (perfilId) {
            return await http.get(PREFIX + "/" + perfilId + "/permissions", {customConfig})
        }
        
        return await http.get(PREFIX + "/permissions", {customConfig})
    },
    async savePermissoes(perfilId, permissoes, customConfig)
    {
        return await http.post(PREFIX + "/" + perfilId + "/permissions", permissoes, {customConfig})
    }
  }